export function CopyIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}>
      <g clip-path="url(#clip0_565_2824)">
        <path d="M3.75 11.2502C3.05109 11.2502 2.70163 11.2502 2.42597 11.1361C2.05843 10.9838 1.76642 10.6918 1.61418 10.3243C1.5 10.0486 1.5 9.69916 1.5 9.00024V3.90024C1.5 3.06017 1.5 2.64013 1.66349 2.31926C1.8073 2.03702 2.03677 1.80754 2.31901 1.66373C2.63988 1.50024 3.05992 1.50024 3.9 1.50024H9C9.69891 1.50024 10.0484 1.50024 10.324 1.61442C10.6916 1.76667 10.9836 2.05868 11.1358 2.42622C11.25 2.70188 11.25 3.05133 11.25 3.75024M9.15 16.5002H14.1C14.9401 16.5002 15.3601 16.5002 15.681 16.3368C15.9632 16.1929 16.1927 15.9635 16.3365 15.6812C16.5 15.3604 16.5 14.9403 16.5 14.1002V9.15024C16.5 8.31016 16.5 7.89013 16.3365 7.56926C16.1927 7.28701 15.9632 7.05754 15.681 6.91373C15.3601 6.75024 14.9401 6.75024 14.1 6.75024H9.15C8.30992 6.75024 7.88988 6.75024 7.56901 6.91373C7.28677 7.05754 7.0573 7.28701 6.91349 7.56926C6.75 7.89013 6.75 8.31016 6.75 9.15024V14.1002C6.75 14.9403 6.75 15.3604 6.91349 15.6812C7.0573 15.9635 7.28677 16.1929 7.56901 16.3368C7.88988 16.5002 8.30992 16.5002 9.15 16.5002Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_565_2824">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

CopyIcon.displayName = 'CopyIcon';
